module.exports = __webpack_public_path__ + "static/logo-ca5d9d40ca4f8c9139675449f87e07ff.png";